import { render } from "./OTable.vue?vue&type=template&id=eb505e8c&scoped=true"
import script from "./OTable.vue?vue&type=script&lang=js"
export * from "./OTable.vue?vue&type=script&lang=js"

import "./OTable.vue?vue&type=style&index=0&id=eb505e8c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb505e8c"]])

export default __exports__